import React from 'react';

import starTokens from '@amzn/meridian-tokens/base/icon/star-filled';
import Icon from '@amzn/meridian/icon';
import Link from '@amzn/meridian/link';
import Table, { TableCell, TableRow } from '@amzn/meridian/table';
import Text from '@amzn/meridian/text';

import { IVendorContact } from 'src/data/VendorContactsData';

import '../VendorContacts.scss';

interface ContactsTableProps {
    contacts: IVendorContact[];
}

export const ContactsTable: React.FC<ContactsTableProps> = ({ contacts }) => {
    return (
        <Table headerRows={1} showDividers={true} stickyHeaderRow={true}>
            <TableRow>
                <TableCell>
                    <Text type="h100">Contact Name</Text>
                </TableCell>
                <TableCell>
                    <Text type="h100">Function</Text>
                </TableCell>
                <TableCell>
                    <Text type="h100">Role</Text>
                </TableCell>
                <TableCell>
                    <Text type="h100">Location</Text>
                </TableCell>
                <TableCell>
                    <Text type="h100">Email</Text>
                </TableCell>
                <TableCell>
                    <Text type="h100">Phone</Text>
                </TableCell>
                <TableCell>
                    <Text type="h100">Primary POC</Text>
                </TableCell>
            </TableRow>
            {contacts.map((contact) => (
                <TableRow key={contact.id}>
                    <TableCell>
                        <Text>{contact.name}</Text>
                    </TableCell>
                    <TableCell>
                        <Text>{contact.function}</Text>
                    </TableCell>
                    <TableCell>
                        <Text>{contact.role}</Text>
                    </TableCell>
                    <TableCell>
                        <Text>{contact.location}</Text>
                    </TableCell>
                    <TableCell>
                        <Link href={`mailto:${contact.email}`}>
                            <Text>{contact.email}</Text>
                        </Link>
                    </TableCell>
                    <TableCell>
                        <Link href={`tel:${contact.phone}`}>
                            <Text>{contact.phone}</Text>
                        </Link>
                    </TableCell>
                    <TableCell>{contact.isPrimary && <Icon className="primary-star" tokens={starTokens} />}</TableCell>
                </TableRow>
            ))}
        </Table>
    );
};
